import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.25rem',
    cursor: 'pointer'
  }
}))

export default useStyles
